
import Card from "../Card.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Card,
  },
  data() {
    return {
      query: "",
      displayModal: false,
      modal1: false,
      goalsArgs: {
        totalRead: "",
        pagesPerDay: "",
        pagesPerWeek: "",
        monthlyRead: "",
      },
    };
  },
  computed: {
    ...mapGetters(["getUserGoals", "getUserBooks"]),
    currentGoal() {
      const goals = this.getUserGoals.books;
      if (!goals || !goals.length) {
        return null;
      }
      const sortedBooks = goals.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      return sortedBooks[0];
    },
  },
  async mounted() {
    await this.bookGoal();
  },
  methods: {
    async createGoals() {
      let res = await this.$store.dispatch("post", {
        endpoint: `/book-goals/`,
        auth: true,
        payload: this.goalsArgs,
      });
      if (res.status == 201) {
      }
    },
    async bookGoal() {
      let res = await this.$store.dispatch("get", {
        endpoint: `/book-goals/`,
        auth: true,
      });
      if (!!res) {
        this.$store.commit("set", {
          type: "userGoals",
          data: res,
        });
      }
    },
  },
};
